// extracted by mini-css-extract-plugin
export default {"container":"_28_F_Ps1A2407Mnksyas-L"};